export default {
  // 页面标题
  title: '方案',
  
  // 百万美元补贴
  millionDollarSubsidy: 'AhaCreator 百万美元补贴',
  
  // 按需付费部分
  payAsYouGo: {
    title: '按需付费',
    influencerMarketingBudget: '达人营销预算',
    aiMarketerCosts: 'AI 员工薪资',
    total: '总计'
  },
  
  // 退款政策
  refund: {
    title: '100% 退款保障',
    conditions: {
      contentDelivery: '若达人未交付内容',
      nonOrganicPerformance: '若通过非自然流量（刷量/虚假互动）提升数据',
      overdueSubmission: '若达人提交逾期',
      aiGeneratedContent: '若内容未产生价值或完全由 AI 生成'
    }
  },
  
  // 预算选项
  budgetOptions: {
    monthly: 'USD / 月'
  }
};
